enum ValuersActionsEnum {
    ValuersList = 'VALUERS/LIST',
    ValuersSet = 'VALUERS/SET',
}

export default ValuersActionsEnum;
